import { AxiosInstance } from 'axios'
import { Alpha3Code } from 'i18n-iso-countries'

import { Money } from '@percent/utility'
import { TableColumnSortDirection } from '@percent/lemonade'

export type FundraisersServiceCapabilities = {
  percentClient: AxiosInstance
}

export enum FundraiserStatus {
  Published = 'published',
  Closed = 'closed'
}

export enum FundraiserVisibility {
  LISTED = 'listed',
  UNLISTED = 'unlisted',
  PUBLIC = 'public'
}

export type GetFundraisersListProps = {
  page?: number | null
  pageSize?: number | null
  status?: FundraiserStatus[] | string | null
  query?: string | null
  featuredOnly?: boolean
  visibility?: FundraiserVisibility
  sort?: 'title' | 'createdAt' | 'amount' | 'featuredAt' | null
  direction?: TableColumnSortDirection | null
}

export type Fundraiser = {
  id: string
  status: FundraiserStatus
  organisation: {
    name: string
  }
  organiser: {
    kind: string
    id: string
    name: string
    email: string
  }
  campaign: {
    goal?: Money
  }
  page: {
    title: string
    logo?: string
  }
  donationTotal: Money
  createdAt: string
  endAt: string | null
  featured?: {
    featuredItemId: string
    country: Alpha3Code[]
  }
  visibility?: FundraiserVisibility
}
